import type {DatabagRouteMatch} from "../../../routing/catRoutes";
import {routes} from "../../../routing/routes";
import {generatePath} from "react-router";

export type Intent = {
    type: 'by_supplier'
    supplier: string
} | ByPartIntent
export type ByPartIntent = {
    type: 'by_part'
    part_search: string
    /**
     * @deprecated TODO: update to reflect filterModel changes
     */
    part_search_fields: (Exclude<string, 'p_id'>)[] // TODO: p_id is not build yet
};

export type UrlState = {
    searchIntent: Intent | null
}

export const BY_SUPPLIER_VALUE = 'supplier';
export const BY_PART_VALUE = 'search';
export const BY_PART_FIELDS = 'f';

export function urlToIntent(urlParams: URLSearchParams): Intent | null {
    if (urlParams.has(BY_SUPPLIER_VALUE)) {
        return {
            type: 'by_supplier',
            supplier: urlParams.get(BY_SUPPLIER_VALUE)!
        }
    }
    if (urlParams.has(BY_PART_VALUE)) {
        return {
            type: 'by_part',
            part_search: urlParams.get(BY_PART_VALUE)!,
            part_search_fields: urlParams.getAll(BY_PART_FIELDS)
        }
    }
    return null;
}

export function intentToURL(path: string, prevParams: URLSearchParams, intent: Intent): string {
    if (!path) return ''
    const params = new URLSearchParams(prevParams);

    if (intent.type === 'by_supplier') {
        params.set(BY_SUPPLIER_VALUE, intent.supplier);
    } else {
        intent.part_search_fields.forEach(f => params.append(BY_PART_FIELDS, f));
        params.set(BY_PART_VALUE, intent.part_search);
    }

    return path + '?' + params.toString()
}

export function buildPath(databag: number): string {
    const params: DatabagRouteMatch = {id: String(databag)};
    // if (environment.package === 'cleanup') {
    // }
    return generatePath(routes.cleanup_categorization, params);
}
